export function formatPrice(price: number | undefined, decimals: number = 2): string {
  if (price === undefined) return '-';
  const roundedPrice = price.toFixed(decimals);

  // remove trailing 0s and the dot if the price is an integer
  return `€${roundedPrice.replace(/(\.0+|0+)$/, '')}`;
}
